import React from "react";
import { Link, useNavigate } from "react-router-dom";
import courseImg1 from "../../assets/images/course/1.png";

import coursetypeIcon from "../../assets/images/course/beg.png";

const SingleCourseThree = (props) => {
  const navigate = useNavigate();
  const { itemClass,course,name} = props;

  const handleClick = () => {
    // Use navigate to redirect to the course detail page and pass the course data in the state
    navigate(`/coursesDetail/${course.name}`, { state: { course:course,name:name } });
  };
  return (
    <div className={itemClass ? itemClass : "single-studies grid-item"}>
   
   <div className="inner-course" onClick={handleClick}> 
          <div className="case-img">
            <Link to="#" className="cate-w">
              <img src={coursetypeIcon} alt={""} />
              {course.levels ? course.levels : "Beginner"}
            </Link>
            <img crossorigin="anonymous"
              src={
               course.thumbnail
                  ? `https://back.yourfrenchteachers.com/${course.thumbnail}`
                  : courseImg1
              }
              alt={course.name}
            />
          </div>
          <div className="case-content">
            <h4 className="case-title">
              <Link to={`/course/${course._id}`}>{course.name}</Link>
            </h4>
            <ul className="meta-course">
             {
              !!course.lectureCount  && (
                 <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-book"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
                {course.lectureCount} Lecture
              </li>
              )
             }
            {
              !name?.toLowerCase().includes("video") && (
                  <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-clock"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              max - {course.maxStudents}
              </li>
              )
            }
            </ul>

            <ul className="react-ratings">
              <li className="price course-price">{course.price}</li>
            </ul>
          </div>
        </div>
     
    </div>
  );
};

export default SingleCourseThree;
